<template>
  <b-container fluid>
    <b-row class="details ml-5 mr-3">
      <b-col xl="12" lg="12" sm="12">
          <b-row>
              <b-col xs="12" sm="12" md="12" class="text-right mb-2">
                  <b-button @click="pdfExport()" variant="success">{{  $t('globalTrans.export_pdf') }}</b-button>
              </b-col>
          </b-row>
          <b-row class="ml-4 mr-3" v-if="reportHeadData">
              <b-col xs="12" sm="12" md="3" class="text-right mt-4">
                  <b-img :src="`${ reportHeadData.reportHeadColumn[0].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
              </b-col>
              <b-col xs="12" sm="12" md="6" class="text-center mt-2">
                  <h6 class="text-dark">
                      {{ $t('production_store.govt_info') }}
                  </h6>
                  <h4 class="text-center text-dark">
                      <span v-if="reportHeadData.organizationName">{{ reportHeadData.organizationName }}</span>
                      <span v-else>{{ currentLocale == 'en' ? 'Bangladesh National Social Welfare Council' : 'বাংলাদেশ জাতীয় সমাজকল্যাণ পরিষদ' }} </span>
                  </h4>
                  <span class="text-center text-dark">
                      {{ reportHeadData.heading }}
                  </span><br>
                  <span class="text-center text-dark">
                      {{ reportHeadData.address }}
                  </span><br>
              </b-col>
              <b-col xs="12" sm="12" md="3" class="text-left mt-4">
                  <b-img :src="`${ reportHeadData.reportHeadColumn[1].image }`" fluid alt="BD Image" style="width:35%;border-radius:50%;"></b-img>
              </b-col>
              <b-col xs="12" sm="12" md="12" class="mt-4 mb-1 text-dark">
                <b-row>
                    <b-col sm="6">
                        <span class="float-left">{{ detailsFormData.circular_memo_no }}</span>
                    </b-col>
                    <b-col sm="6">
                        <span class="float-right">{{ $t('globalTrans.date') }}: {{ formatDate(detailsFormData.updated_at) }}</span>
                    </b-col>
                    <b-col sm="12">
                        <div class="text-dark text-center" style="font-weight:bold; font-size: 18px">
                            {{ ($i18n.locale === 'bn' ? detailsFormData.title_bn : detailsFormData.title_en) }}
                        </div>
                    </b-col>
                  </b-row>
              </b-col>
          </b-row>
          <b-row class="ml-4 mr-3">
              <b-col xl="12" lg="12" sm="12">
                <p class="text-dark text-justify">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span v-if="$i18n.locale == 'bn'">{{ 'বাংলাদেশ জাতীয় সমাজকল্যাণ পরিষদ হতে ' + detailsFormData.fiscal_year_bn + ' অর্থবছরে নিবন্ধিত স্বেচ্ছাসেবী সমাজকল্যাণ সংগঠনসমূহের অনুকূলে এককালীন আর্থিক অনুদান প্রদান করা হবে। নির্দিষ্ট সময়ের মধ্যে নিম্নবর্ণিত যোগ্যতা সম্পন্ন সমাজকল্যাণমূলক সংগঠনসমূহকে নির্ধারিত ফরমে সংশ্লিষ্ট কার্যালয়ে প্রয়োজনীয় কাগজপত্রসহ আবেদনপত্র জমাদানের জন্য অনুরোধ করা হলো:-' }}</span>
                  <span v-else>{{ 'Bangladesh National Social Welfare Council will provide a one-time financial grant in favor of registered voluntary social welfare organizations in the fiscal year ' + detailsFormData.fiscal_year_en + '. Within the specified period, the social welfare institutions having the following qualifications are requested to submit the application form along with the necessary documents to the concerned office in the prescribed form:-' }}</span>
                </p>
                  <b-table-simple striped bordered small hover>
                      <thead>
                        <b-tr class="text-center">
                            <b-th>{{ $t('grant_process.ins_type') }}</b-th>
                            <b-th>{{ $t('grant_process.application_place') }}</b-th>
                            <b-th>{{ $t('grant_process.application_fee') }}</b-th>
                            <b-th>{{ $t('globalTrans.action') }}</b-th>
                        </b-tr>
                      </thead>
                      <tbody>
                        <b-tr v-for="(item, index) in services" :key="index">
                            <b-td>
                              {{ '(' + $n(index+1) + ') ' + ($i18n.locale === 'en' ? item.text_en : item.text_bn) }}
                            </b-td>
                            <b-td class="text-center">
                              <span v-for="(itm, indx) in item.office_type" :key="indx">
                                <span>{{ getOfficeTypeName(itm.office_type_id) }}</span><span v-if="indx+1 < item.office_type.length">{{ ', ' }}</span>
                              </span>
                            </b-td>
                            <b-td class="text-center">{{ $n(item.fee) }}</b-td>
                            <b-td>
                              <a @click="setServiceUrl(item)" href="javascript:" title="Apply" variant=" iq-bg-primary" size="sm">
                                  {{ $t('globalTrans.apply') }}
                              </a>
                            </b-td>
                        </b-tr>
                      </tbody>
                  </b-table-simple>
                  <b-table-simple small>
                      <tbody>
                          <b-tr>
                              <b-td width="20%">{{ $t('globalTrans.description') }}</b-td>
                              <b-td colspan="3">{{ ($i18n.locale === 'bn' ? detailsFormData.description_bn : detailsFormData.description_en) }}</b-td>
                          </b-tr>
                          <b-tr>
                              <b-td>{{ $t('grant_process.deadline') }}</b-td>
                              <b-td>{{ detailsFormData.deadline | dateFormat }}</b-td>
                              <b-td>{{ $t('globalTrans.attachment') }}</b-td>
                              <b-td>
                                  <span v-if="detailsFormData.attachment">
                                  <a :href="url + 'download-attachment?file=' + 'uploads/admin/circular/original' + '/'
                                      + detailsFormData.attachment" target="_blank" rel="noopener noreferrer">
                                      <!-- {{ detailsFormData.attachment }} -->
                                      <span class="badge badge-success">
                                          {{$t('globalTrans.download')}} <i class="ri-download-cloud-line" ></i>
                                      </span>
                                  </a>
                                  </span>
                              </b-td>
                          </b-tr>
                      </tbody>
                  </b-table-simple>
                  <div class="row">
                      <div class="col-sm-3"></div>
                      <div class="col text-right">
                          <b-button variant="danger" class="mr-1" @click="$bvModal.hide('modal-5')">{{ $t('globalTrans.close') }}</b-button>
                      </div>
                  </div>
              </b-col>
          </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>
<script>
import { grantAllowanceServiceBaseUrl } from '@/config/api_config'
import ExportPdf from './export-pdf_details'
import ReportHeading from '@/Utils/report-head'
import moment from 'moment'

export default {
    props: ['id', 'serviceNameList'],
    components: {},
    data () {
        return {
            org_id: 4,
            reportHeadData: null,
            services: [],
            detailsFormData: {},
            url: grantAllowanceServiceBaseUrl
        }
    },
    created () {
        this.headerName()
        if (this.id) {
            const tmp = this.getInstituteInfoData()
            this.detailsFormData = tmp
            const servIds = JSON.parse(this.detailsFormData.service_ids)
            this.services = this.serviceNameList.filter(item => servIds.includes(item.value))
        }
    },
    mounted () {
        // core.index()
    },
    computed: {
      currentLocale () {
          return this.$i18n.locale
      }
    },
    methods: {
        formatDate (date) {
          return moment(date).format('DD/MM/YYYY')
        },
        setServiceUrl (item) {
            const url = '/grant-public-panel/service-application-form?tracking_id=' + item.tracking_no + '&&c_id=' + this.id
            // const url = '/grant-public-panel/service-application-form?tracking_id=' + item.tracking_no
            this.$store.dispatch('Portal/setServiceUrl', {
                externalPanelServiceUrl: url,
                externalPanelCurrentServiceUrl: url
            })
            this.$router.push('/auth/login')
        },
        getOfficeTypeName (Id) {
          const Obj = this.$store.state.Portal.commonObj.officeTypeList.find(el => el.value === parseInt(Id))
          if (typeof Obj !== 'undefined') {
            return this.$i18n.locale === 'en' ? Obj.text_en : Obj.text_bn
          }
          return ''
        },
        getInstituteInfoData () {
            const tmpData = this.$store.state.list.find(item => item.id === this.id)
            return JSON.parse(JSON.stringify(tmpData))
        },
        async headerName () {
            const headData = await ReportHeading.getReportHead(grantAllowanceServiceBaseUrl, 'configuration/report-heading/detail', this.org_id)
            this.reportHeadData = headData
        },
        pdfExport () {
            ExportPdf.exportPdfDetails(grantAllowanceServiceBaseUrl, 'configuration/report-heading/detail', 4, this)
        }
    }
}

</script>
<style lang="scss">
    .details {
    h5 {
      color: green !important;
      font-size: 20px !important;
    }
    // .table-bordered td:nth-child(2n+1) {
    //   font-weight: 700;
    // }
    .table-bordered th:nth-child(2n+1) {
      font-weight: 700;
    }
  }
  .hidden_header {
    display: none
  }
  [dir=ltr][mode=light] .card-body {
    flex: 1 1 auto;
    min-height: 1px;
    padding: 10px;
  }
</style>
